import { Col, Container, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { useFirestore, useFunctions } from "reactfire";
import { FaPencilAlt } from "react-icons/fa";
import "./styles.scss";
// @ts-ignore
import renderHTML from "react-render-html";
import FormValidator from "../../../../../../shared/utils/FormValidator";
import UserNotification from "../../../../../../shared/components/Notification/UserNotification";
import PageHeader from "../../../../components/page-header/PageHeader";
import ConfirmationModal from "../../../../../../shared/components/confirmationModal/ConfirmationModal";

interface IntroState {
  description: string;
  // country: Country;
}

interface ErrorState {
  loading: boolean;
  descriptionError: string;
}

interface State {
  showAcceptConfirmation: boolean;
  showClearConfirmation: boolean;
}

const initState: State = {
  showAcceptConfirmation: false,
  showClearConfirmation: false,
};

const initIntroState: IntroState = {
  description: "",
  // country: Country.SRI_LANKA,
};

const initErrorState: ErrorState = {
  loading: false,
  descriptionError: "",
};

const AlumniDescription = () => {
  const store = useFirestore();
  const [state, setState] = useState(initState);
  const [errorState, setErrorState] = useState(initErrorState);
  const [introState, setIntroState] = useState({
    ...initIntroState,
  });
  const [previewState, setPreviewState] = useState(true);
  const [isUpdate, setIsUpdate] = useState(false);
  const saveIntroRef = useFunctions().httpsCallable("saveAlumniDescription");

  useEffect(() => {
    return store.collection("alumniDescription").onSnapshot({}, (snapshot) => {
      snapshot.docs.length > 0 ? setPreviewState(true) : setPreviewState(false);

      snapshot.docChanges().forEach((change) => {
        if (change.type === "added" || change.type === "modified") {
          setIntroState((prevState) => {
            return Object.assign(
              {},
              {
                description: change.doc.data().description,
              }
            );
          });
        }
        if (change.type === "removed") {
          setIntroState((prevState) => {
            return Object.assign(
              {},
              {
                description: "",
              }
            );
          });
          setPreviewState(false);
        }
      });
    });
  }, [store]);

  const onEditorUpdates = (content: any, editor: any) => {
    setErrorState({ ...errorState, descriptionError: "" });
    if (content !== undefined) {
      setIntroState({ ...introState, description: content });
    }
  };

  const validateForm = () => {
    const validDescription = FormValidator.validateQuestionBody(
      introState.description,
      "Description",
      3,
      1000
    );
    setErrorState({
      ...errorState,
      descriptionError: validDescription.message,
    });
    return validDescription.isValid;
  };

  const clearForm = () => {
    setIntroState({
      ...introState,
      description: "",
    });
    setState({
      ...state,
      showClearConfirmation: false,
    });
    setErrorState({ loading: false, descriptionError: "" });
  };

  const saveIntroduction = () => {
    setErrorState({
      descriptionError: "",
      loading: true,
    });
    const reqBody = {
      description: introState.description,
    };
    saveIntroRef(reqBody)
      .then((res) => {
        if (res.data.data) {
          UserNotification({
            isSuccess: true,
            message: "Alumni Description Saved!",
          });
        } else {
          if (res.data.status === 201) {
            UserNotification({
              isSuccess: true,
              message: "Alumni Description Updated!",
            });
          } else {
            UserNotification({
              isSuccess: false,
              message: "Alumni Description saving failed!",
            });
          }
        }
        setPreviewState(true);
      })
      .catch((error) => {
        UserNotification({
          isSuccess: false,
          message:
            "Alumni Description saving failed!\nPlease check your connection.",
        });
      })
      .finally(() => {
        setErrorState({
          ...errorState,
          loading: false,
        });
        setState({
          ...state,
          showAcceptConfirmation: false,
        });
      });
  };

  return (
    <>
      <PageHeader title="Alumni Description" />
      <Container
        fluid
        style={{
          paddingTop: "200px",
          paddingLeft: "50px",
          paddingRight: "50px",
        }}
      >
        {!previewState ? (
          <>
            <Row>
              <Col xs={12} className="text-right">
                <div
                  className="cancel-button blue"
                  style={{ marginRight: "15px" }}
                  onClick={() => {
                    !errorState.loading &&
                      introState.description &&
                      setState({ ...state, showClearConfirmation: true });
                  }}
                >
                  Clear
                </div>
                <div
                  className="save-button"
                  style={{ marginLeft: "15px" }}
                  onClick={() => {
                    !errorState.loading &&
                      validateForm() &&
                      setState({ ...state, showAcceptConfirmation: true });
                  }}
                >
                  Save
                </div>
              </Col>
            </Row>
            <Row>
              <Col
                xs={12}
                className="text-left font-weight-bold"
                style={{ color: "rgb(7, 66, 94)", width: "100%" }}
              >
                <label style={{ color: "#505050", fontWeight: "bold" }}>
                  Alumni Description{" "}
                  <span className="ml-1" style={{ color: "red" }}>
                    *
                  </span>
                </label>
                <Editor
                  apiKey={"t5wauipzy7x1msgvu2y1n2x4fg9vdd3nzbumusv71li0ys00"}
                  initialValue={introState.description}
                  value={introState.description}
                  init={{
                    images_upload_handler: async (
                      blobInfo: any,
                      success: Function,
                      failure: Function
                    ) => {
                      //need to code
                    },
                    height: 350,
                    width: "100%",
                    plugins: [
                      "advlist autolink lists link image charmap print preview anchor",
                      "searchreplace visualblocks code fullscreen",
                      "insertdatetime media table paste code help wordcount",
                    ],
                    image_uploadtab: true,
                    image_description: false,
                    image_dimensions: true,
                    paste_data_images: true,
                    automatic_uploads: false,
                    mobile: {
                      menubar: false,
                      object_resizing: true,
                      resize: true,
                      imagetools_toolbar:
                        "rotateleft rotateright | flipv fliph imageoptions",
                      toolbar1:
                        "undo redo | bold italic forecolor backcolor | formatselect | alignleft aligncenter alignright alignjustify | help ",
                      toolbar2:
                        "fullscreen | link image table | bullist numlist outdent indent | removeformat",
                    },
                    menubar: true,
                    object_resizing: true,
                    resize_img_proportional: true,
                    imagetools_toolbar:
                      "rotateleft rotateright | flipv fliph | editimage imageoptions",
                    toolbar1:
                      "undo redo | bold italic forecolor backcolor | formatselect | alignleft aligncenter alignright alignjustify | help ",
                    toolbar2:
                      "link image table | bullist numlist outdent indent | removeformat",
                  }}
                  onEditorChange={onEditorUpdates}
                />
                <label className="error-message font-weight-bold pt-2">
                  {errorState.descriptionError}
                </label>
              </Col>
            </Row>
            <Row></Row>
            {state.showClearConfirmation && (
              <ConfirmationModal
                children={{
                  bodyText: "Are you sure you want to clear all the content?",
                  headerText: "Confirm Changes",
                  confirmButtonText: "Clear Content",
                  cancelButtonText: "Cancel",
                  confirmButtonColor: "red",
                }}
                loading={errorState.loading}
                show={state.showClearConfirmation}
                onCancel={() =>
                  !errorState.loading &&
                  setState({ ...state, showClearConfirmation: false })
                }
                onConfirm={() => {
                  clearForm();
                }}
              />
            )}
            {state.showAcceptConfirmation && (
              <ConfirmationModal
                children={{
                  bodyText: !isUpdate
                    ? "Are you sure you want to save the content?"
                    : "Are you sure you want to update the content?",
                  headerText: isUpdate ? "Confirm Updates" : "Confirm Save",
                  confirmButtonText: isUpdate ? "Update" : "Save",
                  cancelButtonText: "Cancel",
                  confirmButtonColor: "blue",
                }}
                loading={errorState.loading}
                show={state.showAcceptConfirmation}
                onCancel={() =>
                  !errorState.loading &&
                  setState({ ...state, showAcceptConfirmation: false })
                }
                onConfirm={() => {
                  saveIntroduction();
                }}
              />
            )}
          </>
        ) : (
          <>
            <Row>
              <Col
                xs={12}
                className="d-flex justify-content-end"
                style={{ marginBottom: "10px" }}
              >
                {previewState && (
                  <div
                    className="edit mr-2"
                    onClick={(e) => {
                      setIsUpdate(true);
                      setPreviewState(false);
                    }}
                  >
                    <FaPencilAlt /> <span>Edit</span>
                  </div>
                )}
                {/*<div className="remove" onClick={(e) => {}}>*/}
                {/*  <RiDeleteBin5Line /> <span>Remove</span>*/}
                {/*</div>*/}
              </Col>
            </Row>
            <Row>
              <Col
                xs={12}
                className="text-left font-weight-bold"
                style={{ color: "rgb(7, 66, 94)", width: "100%" }}
              >
                {renderHTML(introState.description)}
              </Col>
            </Row>
          </>
        )}
      </Container>
      {/* <WorkshopCopyModel
        show={showCopyDialog}
        onHide={() => setShowCopyDialog(false)}
        activeList={{
          curriculum: false,
          libraryHome: true,
          workshopContent: false,
        }}
      /> */}
    </>
  );
};

export default AlumniDescription;
